import React from "react";
import "./panel-replacement.css";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
export default function PanelReplacement() {
  return (
    <>
    <Helmet>
      <title>Car Panel Replacement Service in Palwal | AutoCare</title>
      <meta
        name="description"
        content="Need car panel replacement in Palwal? AutoCare offers expert door, fender, bonnet, and quarter panel replacement with genuine parts and perfect paint matching."
      />
      <link
        rel="canonical"
        href="https://car-repair-mechanic-palwal.netlify.app/services/panel-replacement"
      />
    </Helmet>
    <section className="servicePage">
      <div className="serviceContent">

        {/* TEXT SECTION */}
        <div className="textContent">
          <h1>Car Panel Replacement Service in Palwal</h1>

          <p>
            Severely damaged or rusted car panels can affect both safety and looks.
            At <strong>AutoCare</strong>, we provide professional
            <span className="highlight"> car panel replacement services</span>
            using genuine parts and advanced repair techniques.
            Trusted <strong>Auto Care in Palwal</strong> for complete
            <span className="highlight"> car repair</span>.
          </p>

          <h2>What is Panel Replacement?</h2>
          <p>
            Panel replacement is a critical <span className="highlight">
            car body repair</span> process where damaged panels such as doors,
            fenders, bonnets, or quarter panels are removed and replaced with
            new or genuine-fit panels to restore structural integrity.
          </p>

          <h2>Our Panel Replacement Services Include</h2>
          <ul>
            <li>Door panel replacement</li>
            <li>Fender & quarter panel replacement</li>
            <li>Bonnet & boot panel replacement</li>
            <li>Accidental damage panel repair</li>
            <li>Perfect paint matching after replacement</li>
          </ul>

          <h2>Why Choose AutoCare for Panel Replacement?</h2>
          <ul>
            <li>Certified technicians & modern tools</li>
            <li>Genuine and OEM-quality spare panels</li>
            <li>Transparent pricing & timely delivery</li>
            <li>Trusted <span className="highlight">Auto Care in Palwal</span></li>
            <li>Complete <span className="highlight">car repair</span> solutions</li>
          </ul>

          <h2>Book Panel Replacement Service with AutoCare</h2>
          <p>
            Searching for reliable <span className="highlight">
            car panel replacement near me</span>?
            Choose <strong>AutoCare</strong> for precision work and long-lasting results.
          </p>

          <button className="primaryBtn">
            <Link to="/contact">
            Book Panel Replacement Service
            </Link>
          </button>
        </div>

        {/* IMAGE SECTION */}
        <div className="imageContent">
          <img
            src="/carServiceImages/panelReplacement.webp"
            alt="Car Panel Replacement Service in Palwal"
          />
        </div>
      </div>
    </section>
    </>
  );
}
